import * as React from 'react';
import ProjectListContainer from '../projects/ProjectList.container';
import './ShowInvestorDeck.css';
import { Link } from 'react-router-dom';
import GetProFinanceSectionComponent from 'src/modules/investor-deck/partials/GetProFinanceSection.component';
import SelectionCriteriaSectionComponent from 'src/modules/how-to-invest/partials/SelectionCriteriaSection';

interface Props {
  isLogged: boolean;
  hasInvestorDeck: boolean;
  register: () => void;
}

class ShowInvestorDeckComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {

    const renderButton = () => {
      if (this.props.isLogged) {
        if (this.props.hasInvestorDeck) {
          return null;
        } else {
          return (
            <div className="text-center">
              <Link to="/investor-deck">
                <button
                  className="btn btn-secondary register-button"
                >
                  Enviar mi operación
                </button>
              </Link>
            </div>
          );
        }
      } else {
        return (
          <div className="text-center">
            <button
              className="btn btn-secondary register-button"
              onClick={() => this.props.register()}
            >
              Registrarme para conseguir financiación
            </button>
          </div>
        );
      }
    };

    return (
      <section className="show-investor-deck-component">
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <h1 className="bold-title">
                  Cómo conseguir financiación
                </h1>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-12 col-md-4">
                <p className="breadcrumb text-right">
                  Inicio > cómo financiar tu startup
                </p>
              </div>
            </div>
          </div>
          <div className="row text-center" style={{backgroundColor: '#C2D8BF'}}>
            <img src="./img/section-1.png" alt="section 1"/>
          </div>

          <div className="gap-50"/>

          <div className="container">
            <div className="row row-eq-height">
              <div className="col-md-6 advantages-list">
                <h4 className="f-w-100 invest-title">
                  <strong>La mejor manera de financiar tu Startup</strong>
                </h4>
                <div className="gap-20"/>
                <img
                  className="bullet-point"
                  alt="financiacion rapida"
                  src="/img/01_financiacion_rapida.svg"
                />
                <strong className="invest-subtitle padding-10">
                  Consigue una ronda de financiación de forma rápida.
                </strong>
                <p className="padding-left-30">
                  Gracias a la viralidad de internet, la ayuda de nuestro equipo de expertos y nuestra comunidad de
                  inversores, The Crowd Angel te ayuda a cerrar una ronda de financiación en un plazo de tiempo récord.
                </p>

                <img
                  className="bullet-point"
                  alt="inversores de calidad"
                  src="/img/02_inversores_de_calidad.svg"
                />
                <strong className="invest-subtitle padding-10">
                  Incorpora a inversores de calidad.
                </strong>
                <p className="padding-left-30">
                  Los inversores que incorporas se sienten parte de la startup y actúan como “brand ambassadors” de la
                  misma. Además algunos de ellos son directivos o empresarios del mismo sector, que pueden aportar su
                  gran
                  experiencia para ayudarte a conseguir tus objetivos.
                </p>

                <img
                  className="bullet-point"
                  alt="ronda estructurada"
                  src="/img/03_ronda_estructurada.svg"
                />
                <strong className="invest-subtitle padding-10">
                  Ronda de financiación estructurada.
                </strong>
                <p className="padding-left-30">
                  Sabemos que es probable que en el futuro necesites nuevas rondas de financiación. Por ello es muy
                  importante que la ronda esté bien estructurada para que facilite la entrada de futuros inversores
                  estratégicos.
                </p>

                <img
                  className="bullet-point"
                  alt="nuevos clientes"
                  src="/img/04_nuevos_clientes.svg"
                />
                <strong className="invest-subtitle padding-10">
                  Consigue nuevos clientes, no solo financiación.
                </strong>
                <p className="padding-left-30">
                  La visibilidad obtenida durante la campaña de financiación actúa también incrementando las ventas y
                  visibilidad de tu startup.
                </p>

                <img
                  className="bullet-point"
                  alt="crecer tu negocio"
                  src="/img/05_crecer_tu_negocio.svg"
                />
                <strong className="invest-subtitle padding-10">
                  Una vez cerrada la inversión, céntrate en hacer crecer tu negocio.
                </strong>
                <p className="padding-left-30">
                  Incorporamos a uno de nuestros inversores a tu Consejo de Administración y nuestro equipo se ocupa de
                  gestionar a los inversores Crowd Angel, así como preparar informes de seguimiento trimestrales para
                  mantener al día a los inversores.
                </p>

              </div>
              <div className="col-sm-6">
                <img
                  className="lateral-image"
                  alt="step 1"
                  src="/img/step-1.jpg"
                />
              </div>
            </div>
            <div className="gap-20"/>
            {renderButton()}
            <div className="gap-40"/>
          </div>

          <div className="backg" style={{paddingRight: '135px', paddingLeft: '135px'}}>
            <div className="col-md-8">
              <div className="gap-20"/>
              <h4 className="f-w-100 invest-title">
                <strong>Cómo funciona The Crowd Angel para una startup</strong>
              </h4>
              <div className="gap-20"/>
            </div>

            <div className="how-works-list">
              <div className="gap-20"/>
              <div className="row">
                <div className="col-sm-6">
                  <strong className="number-points">1.- </strong>
                  <strong className="padding-10 invest-subtitle">
                    Envíanos la documentación sobre tu empresa.
                  </strong>
                  <p className="padding-left-30">
                    Tan solo hará falta que te registres, completes tus datos personales, contestes un breve formulario
                    y
                    nos envíes una presentación para inversores. Analizaremos tu presentación y si encaja con el perfil
                    de
                    operaciones que buscamos, te propondremos reunirnos y empezará el proceso de análisis y selección.
                    <br/>
                    Toda la información y documentación que nos hagas llegar será tratada con carácter confidencial y,
                    será usada única y exclusivamente para prestarte el mejor servicio posible. En el caso de falta de
                    información, nuestro equipo se pondrá directamente en contacto contigo.
                  </p>

                  <strong className="number-points">2.- </strong>
                  <strong className="padding-10 invest-subtitle">
                    Análisis y estructuración de la operación.
                  </strong>
                  <p className="padding-left-30">
                    Nuestro equipo analizará la viabilidad de la compañía y la operación de inversión, y trabajaremos en
                    la mejor estructuración de la operación (valoración, pacto de socios, coinversores, etc.) que te
                    permita seguir creciendo.
                  </p>

                  <strong className="number-points">3.- </strong>
                  <strong className="padding-10 invest-subtitle">
                    Preparación de la campaña.
                  </strong>
                  <p className="padding-left-30">
                    Una vez la operación está aprobada, te asesoraremos en preparar una presentación para inversores
                    profesional. También te asignamos un miembro del equipo de Fundraising, que te ayudará a preparar
                    una
                    campaña de visibilidad para captar la atención de los inversores.
                  </p>
                </div>

                <div className="col-sm-6">
                  <strong className="number-points">4.- </strong>
                  <strong className="padding-10 invest-subtitle">
                    Publicación de la operación.
                  </strong>
                  <p className="padding-left-30">
                    La operación se publicará por un plazo máximo de 2 meses ante todos los inversores de la plataforma.
                    Durante este periodo, los inversores analizarán la documentación de la operación y si les gusta,
                    comprometerán una inversión.
                    <br/>
                    ¿Cuándo se acaba la fase de publicación?
                    <ul>
                      <li>Si finaliza el plazo de 2 meses, y no se ha alcanzado como mínimo al 90% del objetivo de
                        inversión, se cancelará la operación, y por lo tanto, no se hará la inversión.
                      </li>
                      <li>Si finaliza el plazo de 2 meses, y la ronda ha superado el 90% del objetivo de inversión, pero
                        no ha alcanzado al 125% del objetivo, la ronda se llevará adelante con la cantidad de
                        compromisos
                        de inversión que se hayan conseguido hasta el momento.
                      </li>
                      <li>Si antes de que se acabe el plazo, la ronda llega al máximo del 125% del objetivo de
                        inversión,
                        cerraremos esta fase y pasaremos a formalizar la inversión.
                      </li>
                    </ul>
                  </p>

                  <strong className="number-points">5.- </strong>
                  <strong className="padding-10 invest-subtitle">
                    Proceso de formalización.
                  </strong>
                  <p className="padding-left-30">
                    Durante la campaña de financiación, encargamos a un tercero una Due Diligence de la compañía. Si
                    esta
                    no tiene salvedades importantes, una vez se consiga el importe deseado, procederemos a la
                    formalización de la operación: firma online de los documentos legales que correspondan (Pacto de
                    Socios y Acuerdo de Sindicación), desembolsos de las cantidades comprometidas por los inversores,
                    elevación a público del acuerdo de ampliación de capital en virtud del cual se produce la entrada de
                    los inversores como nuevos socios de la empresa, e inscripción en el Registro Mercantil de la
                    escritura de ampliación de capital.
                    <br/>
                    No te preocupes, recibirás asistencia durante todos el proceso.
                  </p>

                  <strong className="number-points">6.- </strong>
                  <strong className="padding-10 invest-subtitle">
                    Seguimiento de la operación.
                  </strong>
                  <p className="padding-left-30">
                    Una vez formalizada la operación, pasarás a formar parte del portfolio de The Crowd Angel, uno de
                    los
                    inversores, si fuera el caso, pasa a formar parte del Consejo de Administración de la empresa en la
                    que hayas entrado como socios y, nosotros, nos encargaremos de preparar informes de seguimiento y
                    gestionar a la totalidad de los inversores-socios para que actúen de forma sindicada.
                  </p>
                </div>

              </div>

              <div className="gap-20"/>
              {renderButton()}
              <div className="gap-50"/>
            </div>

          </div>

          <GetProFinanceSectionComponent/>

          <div className="gap-20"/>
          {renderButton()}
          <div className="gap-40"/>

          <SelectionCriteriaSectionComponent/>

          <div className="gap-50"/>
          <div className="container">
            <div className="row">
              <h3 className="bold-subtitle">
                  Nuestro Portfolio
              </h3>
              <div className="gap-20"/>
              <ProjectListContainer
                status="closed"
                limit={4}
                listKey="howToInvestPortfolio"
                isSimple={true}
                carousel={true}
                numberOfItems={3}
              />
            </div>
          </div>

          <div className="gap-50"/>
          {renderButton()}
          <div className="gap-40"/>

        </div>

      </section>
    );
  }

}

export default ShowInvestorDeckComponent;



// WEBPACK FOOTER //
// ./src/modules/investor-deck/ShowInvestorDeck.component.tsx